<template>
  <div class="price-skeleton" :class="sizeClass">
    <div class="skeleton-shimmer"></div>
  </div>
</template>

<script>
export default {
  name: 'PriceSkeleton',
  props: {
    size: {
      type: String,
      default: 'medium', // 'small', 'medium', 'large'
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    }
  },
  computed: {
    sizeClass() {
      return `price-skeleton--${this.size}`
    }
  }
}
</script>

<style scoped>
.price-skeleton {
  background-color: #e5e7eb;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  animation: pulse 1.5s ease-in-out infinite;
}

/* Tamanhos */
.price-skeleton--small {
  height: 16px;
  width: 60px;
}

.price-skeleton--medium {
  height: 20px;
  width: 80px;
}

.price-skeleton--large {
  height: 24px;
  width: 100px;
}

.skeleton-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.6) 50%,
    transparent 100%
  );
  animation: shimmer 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Responsivo */
@media (min-width: 768px) {
  .price-skeleton--small {
    height: 18px;
    width: 70px;
  }
  
  .price-skeleton--medium {
    height: 22px;
    width: 90px;
  }
  
  .price-skeleton--large {
    height: 28px;
    width: 110px;
  }
}
</style>

